import CommunityPageHeader from "./CommunityPageHeader";
import MessagesContainer from "./MessagesContainer";
import MessageInput from "./MessageInput";
import '../css/chat_page.css'
import userImage from '../img/user_image.png'
import { useEffect, useState } from "react";
import profileImage from '../img/profile.png'
import { useNavigate } from "react-router-dom";
import { initializeChatWS } from "../helpers/ws";

function ChatPage({countryName, activeCommunitySubcategory, setActiveCommunitySubcategory, phoneNumber, userId, userName, userImage}) {
    const navigate = useNavigate()
    const [messages, setMessages] = useState([])
    const [chatWs, setChatWs] = useState(null)
    const [answeredMessage, setAnsweredMessage] = useState(null)

    useEffect(() => {
        initializeChatWS(setMessages, setChatWs, userId);

        // Cleanup: закрываем соединение при размонтировании или изменении userId
        return () => {
            if (chatWs) {
                chatWs.close();
                setChatWs(null);
            }
        };
    }, [userId, setMessages, setChatWs]);


    return (
        <div className="chat-page">
        <CommunityPageHeader activeCommunitySubcategory={activeCommunitySubcategory} setActiveCommunitySubcategory={setActiveCommunitySubcategory} countryName={countryName} phoneNumber={phoneNumber}/>
        <div className="profile-icon-container" onClick={() => navigate(`/profile?phone=${phoneNumber}`)}>
            <img className="profile-icon" alt='error' src={profileImage}/>
        </div>
        <MessagesContainer messages={messages} userId={userId} setAnsweredMessage={setAnsweredMessage} answeredMessage={answeredMessage}/>
        <MessageInput setMessages={setMessages} userId={userId} userName={userName} userImage={userImage} chatWs={chatWs} answeredMessage={answeredMessage} setAnsweredMessage={setAnsweredMessage}/>
        </div>
    )
};

export default ChatPage;